import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';

function BackButton({ text, page, pageState }) {
  const navigate = useNavigate();

  return (
    <div className="back-button">
      <Button onClick={() => navigate(page, { state: pageState })} sx={{textDecoration:"underline"}}>
        <ArrowLeftIcon />{text}
      </Button>
    </div>
  );
}
export { BackButton };
